import { safeDecodeURI } from '../../utils/safe-decode-uri';

interface PaginationProps {
  routeStatePage: number | string;
  href: string;
}

const pagination = (props: PaginationProps) => {
  const { routeStatePage, href } = props;

  const newUrl = new URL(href);

  if (newUrl.searchParams.has('page')) {
    return href;
  }

  newUrl.searchParams.set('page', String(routeStatePage));

  return safeDecodeURI(newUrl.toString());
};

export default pagination;
